import { Box, Container, Grid, Theme, Typography, useMediaQuery } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import React, { FC } from 'react';
import 'react-multi-carousel/lib/styles.css';
import Image from 'blog/components/Image';

export interface BlockCardProps {
  image: string;
  title?: string;
  text: string;
  isLeftSideImage?: boolean;
  width: number;
  height: number;
  hasDivider?: boolean;
  hasButton?: boolean;
  id?: string;
  orangeTitle?: boolean;
  listItems?: Array<{ text: string }>;
}

const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    title: {
      color: 'rgba(69, 55, 55, 1)',
      fontWeight: 700,
      fontSize: 54,
      [theme.breakpoints.down('sm')]: {
        fontSize: 48,
      },
      [theme.breakpoints.down('xs')]: {
        fontSize: 32,
      },
    },
    orangeTitle: {
      color: theme.palette.primary.main,
      fontWeight: 700,
      fontSize: 54,
      [theme.breakpoints.down('sm')]: {
        fontSize: 48,
      },
      [theme.breakpoints.down('xs')]: {
        fontSize: 32,
      },
    },
    text: {
      color: 'rgba(69, 55, 55, 1)',
      fontSize: 24,
      [theme.breakpoints.down('sm')]: {
        fontSize: 16,
      },
    },
    centeredGrid: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      position: 'relative',
      [theme.breakpoints.down('sm')]: {
        order: 1,
      },
      '& ul': {
        marginLeft: theme.spacing(-3),
        fontSize: 16,
        [theme.breakpoints.up('sm')]: {
          fontSize: 24,
        },
        '& li': {
          '& p': {
            fontSize: 16,
            fontWeight: 700,
            color: `#453737`,
            [theme.breakpoints.up('sm')]: {
              fontSize: 24,
            },
          },
        },
      },
    },
    imageBlock: {
      [theme.breakpoints.down('sm')]: {
        order: 2,
      },
    },
    divider: {
      width: 280,
      height: 4,
      backgroundColor: theme.palette.primary.main,
      margin: theme.spacing(4, 0),
      [theme.breakpoints.down('sm')]: {
        margin: theme.spacing(4, 0, 2),
      },
    },
    boxBtn: {
      backgroundColor: theme.palette.primary.main,
      fontWeight: 500,
      marginTop: theme.spacing(6.6),
      padding: theme.spacing(1.9, 5.3),
      width: 190,
      height: 48,
      cursor: 'pointer',
      '&:hover': {
        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.3)',
      },
    },
    titleBtn: {
      color: theme.palette.common.white,
      fontSize: 16,
    },
    imageWrapper: {
      width: '100%',
      overflow: 'hidden',
    },
    image: {
      width: '100%',
      height: 'auto',
      display: 'block',
      objectFit: 'cover',
    },
  });
});

const BlockCard: FC<BlockCardProps> = (props) => {
  const classes = useStyles();
  const {
    title,
    id,
    text,
    hasDivider = false,
    listItems,
    orangeTitle = false,
    hasButton,
    image,
    isLeftSideImage,
    width,
    height,
  } = props;
  const isMedium = useMediaQuery((theme: Theme) => theme.breakpoints.up('md'));
  const pdfUrl = '/safety-manual.pdf'; // PDF path in public folder

  const handleOpenPdf = () => {
    // Opens the PDF in a new tab
    window.open(pdfUrl, '_blank');
  };

  return (
    <Container data-aos="fade-up" data-aos-delay="400" fixed id={id}>
      <Box mt={isMedium ? 22 : 10.6} />
      <Grid container spacing={6}>
        {!isLeftSideImage ? (
          <Grid item sm={12} md={6} className={classes.centeredGrid}>
            <Typography variant="h1" className={orangeTitle ? classes.orangeTitle : classes.title}>
              {title}
            </Typography>
            <Box mb={4} />
            <Typography className={classes.text}>{text}</Typography>
            {!!listItems?.length && (
              <ul>
                {listItems.map((item, index) => (
                  <li key={index}>
                    <Typography>{item.text}</Typography>
                  </li>
                ))}
              </ul>
            )}
            {hasDivider && <Box className={classes.divider} />}
            {hasButton && (
              <Box className={classes.boxBtn} onClick={handleOpenPdf}>
                <Typography className={classes.titleBtn}>Download Now</Typography>
              </Box>
            )}
          </Grid>
        ) : (
          <Grid className={classes.imageBlock} item sm={12} md={6}>
            <Box className={classes.imageWrapper}>
              <Image src={image} alt={title} width={width} height={height} className={classes.image} />
            </Box>
          </Grid>
        )}

        {!isLeftSideImage ? (
          <Grid className={classes.imageBlock} item sm={12} md={6}>
            <Box className={classes.imageWrapper}>
              <Image src={image} alt={title} width={width} height={height} className={classes.image} />
            </Box>
          </Grid>
        ) : (
          <Grid item sm={12} md={6} className={classes.centeredGrid}>
            <Typography variant="h1" className={orangeTitle ? classes.orangeTitle : classes.title}>
              {title}
            </Typography>
            <Box mb={4} />
            <Typography className={classes.text}>{text}</Typography>
            {!!listItems?.length && (
              <ul>
                {listItems.map((item, index) => (
                  <li key={index}>
                    <Typography>{item.text}</Typography>
                  </li>
                ))}
              </ul>
            )}
            {hasDivider && <Box className={classes.divider} />}
            {hasButton && (
              <Box className={classes.boxBtn} onClick={handleOpenPdf}>
                <Typography>Download Now</Typography>
              </Box>
            )}
          </Grid>
        )}
      </Grid>
    </Container>
  );
};

export default BlockCard;
